// @flow

import { type UserInputValues } from '@tectonics/prs/user-input-values';
import { type IncomingPayment, getCustomerName } from '@tectonics/prs/incoming-payment';
import { type OutgoingPayment } from '../outgoing-payment/types';

export function colombianOutgoingPaymentMapper(userInputValues: UserInputValues, incomingPayment: IncomingPayment): $Shape<OutgoingPayment> {
  const documentType = userInputValues['colombianDocumentType'];

  const outgoingPayment = {
    country: 'co',
    document: userInputValues['colombianDocument'],
    document_type: userInputValues['colombianDocumentType'],
    zipcode: userInputValues['colombianZipcode'],
    state: userInputValues['colombianState'],
    city: userInputValues['colombianCity'],
    address: userInputValues['colombianAddress'],
    street_number: userInputValues['colombianStreetNumber'],
    street_complement: userInputValues['colombianStreetComplement'],
    phone_number: userInputValues['colombianPhoneNumber'],
  };

  if (documentType === 'NIT') {
    return {
      ...outgoingPayment,
      person_type: 'business',
      responsible: {
        name: userInputValues['customerName'] || getCustomerName(incomingPayment),
      },
    };
  }

  return outgoingPayment;
}
